<template>
  <v-dialog v-model="$parent.popup.isVisible" persistent width="400">
    <v-card>
      <v-toolbar class="trHeader" style="height: 40px;">
        <v-toolbar-title class="white--text" style="text-align:center;">{{$parent.popup.title}}</v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs3 right>
          שם סטטוס
        </v-flex>
        <v-flex xs9>
          <input type="text" v-model="$parent.popup.data.Name" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs3 right>
          צבע
        </v-flex>
        <v-flex xs9>
          <ColorPicker ref="colorPicker" v-model="$parent.popup.colors"></ColorPicker>
          <!--<ColorPicker v-model="colors"></ColorPicker>-->
        </v-flex>
      </v-layout>
      <v-flex row wrap style="padding: 10px 10px 10px 10px;">
        <span class="error" v-show="error">* {{error}}</span>
      </v-flex>
      <v-flex actions style="padding: 20px 10px 10px 10px;">
        <v-btn outline small class="green green--text ml-3" @click.native="save">
          שמירה
          <v-icon left>check</v-icon>
        </v-btn>
        <v-btn outline small class="red red--text ml-2" @click.native="cancel">
          ביטול
          <v-icon left>block</v-icon>
        </v-btn>
      </v-flex>
    </v-card>
  </v-dialog>
</template>

<script>
  import { Slider, Compact } from 'vue-color';
  export default {
    name: 'PopupStatus',
    components: { 'ColorPicker': Compact },
    data() {
      return {
        error: '',
        colors: { hex: "#000000" },
      }
    },
    created() {
      this.$Log("Vue [PopupStatus] is created ...");
    },
    ready() {
      this.$Log("Vue [PopupStatus] is ready ...");
    },
    mounted() {
      this.$Log("Vue [PopupStatus] is mounted ...");
    },
    updated() {
      this.$Log("Vue [PopupStatus] is updated ...");
      //this.colors.hex = this.$parent.popup.data.Color;
    },
    methods: {
      isValid() {
        if (this.$parent.popup.data.Name.trim().length <= 0) return false;
        if (this.$parent.popup.data.Color.trim().length <= 0) return false;
        return true;
      },
      save() {
        this.error = "";
        //this.$parent.popup.data.Color = this.refs.colorPicker.pick;
        this.$parent.popup.data.Color = this.$parent.popup.colors.hex;
        if (this.isValid()) {
          if (this.$parent.popup.isEdit) {
            this.$parent.update();
          }
          else {
            this.$parent.insert();
          }
          this.reset();
        }
        else {
          this.error = "נא למלא את כל השדות!"
        }
      },
      cancel() {
        this.reset();
      },
      reset() {
        this.error = "";
        this.$parent.popup = {
          isVisible: false,
          isEdit: false,
          title: '',
          data: { '.key': '', Name: '', Color: '#000000' }
        };
      }
    }
  }

</script>
<style>
  .error {
    color: red;
    background-color: #fff !important;
  }
  .txtRight{
    text-align: right;
    padding-right: 20px;
  }

  .vc-slider {
    padding-right: 50px;
    width: 350px !important;
    position: absolute;
    top: 0px;
    right: 0px;
  }

  .vc-slider-swatches {
    /*display: none !important;*/
  }

  /*.vc-compact {
    width: 100px;
    position: absolute;
    top: 0px;
    right: 0px;
  }*/
</style>



// WEBPACK FOOTER //
// PopupStatus.vue?e7eafb9a